module.exports = __webpack_public_path__ + "img/img_baby_app_2_en.85c91ced.png";